import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { DateTimePicker2 as DateTimePicker, Button } from '../../../form/FormControls.jsx';
import { connect } from 'react-redux';
import { List } from 'immutable';
import RefPicker from '../../../dict/simple/select/DictPicker.jsx';
import Label from '@/component/form/Label.jsx';
import Select from 'react-select';
import FancyInput from '@/component/form/numinput/index.jsx';
import { dateTimePickerFormat, usdDefaultCurrencyRates }
  from '../../../../util/util.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import { PRODUCT_EXPENSES_TYPE } from '../expenses/ExpensesUtils';
import { REF_PATH as EXPENSES_TYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';
import { addDealPayment, updateDealPayment } from '../store/deal.store.js';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import { Currency } from '@/consts/currency';
import RequiredFormControl from '@/component/form/RequiredFormControl.jsx';
moment.locale('en');
momentLocalizer();

class CreatePaymentModal extends React.Component {
  constructor(props) {
    super(props);
    this.closeCreatePaymentModal = this.closeCreatePaymentModal.bind(this);
    this.addNewPayment = this.addNewPayment.bind(this);
    this.setDefaultValues = this.setDefaultValues.bind(this);
    this.validateDueDate = this.validateDueDate.bind(this);
    this.applyDefaultValues = true;
  }

  componentWillMount() {
    this.init();
  }

  componentWillReceiveProps(props) {
    if ((props.show != this.props.show) && props.show) {
      this.init(props);
    }
  }

  setDefaultValues(paymentMethod) {
    switch (paymentMethod) {
      case 'Prepayment':
        this.setState({ paymentObject:
        Object.assign(this.state.paymentObject, {
          fullCostType: 'PERCENT',
          anchor: 'CONTRACT',
          dueDateOffsetType: 'AFTER',
          fullCostPercent: 100,
        }),
        });
        this.validateDueDate('CONTRACT', this.state.paymentObject.dueDate);
        break;
      case 'TT':
        this.setState({ paymentObject:
        Object.assign(this.state.paymentObject, {
          fullCostType: 'PERCENT',
          anchor: 'BLDATE',
          dueDateOffsetType: 'AFTER',
          fullCostPercent: 100,
        }),
        });
        this.validateDueDate('BLDATE', this.state.paymentObject.dueDate);
        break;
      default:
        if (paymentMethod && paymentMethod.indexOf('LC') > -1) {
          this.setState({ paymentObject:
          Object.assign(this.state.paymentObject, {
            fullCostType: 'PERCENT',
            anchor: 'DATE',
            dueDateOffsetType: 'BY',
            fullCostPercent: 100,
          }) });
          this.validateDueDate('DATE', this.state.paymentObject.dueDate);
        }
        break;
    }
  }
  init(props = this.props) {
    const paymentIdx = props.resolvePaymentIdx && props.resolvePaymentIdx();
    const paymentObject = {
      fullCostType: 'VALUE',
      dueDateOffsetType: 'BY',
      anchor: 'DATE',
    };
    if (paymentIdx >= 0) {
      this.applyDefaultValues = false;
      const payment = props.payments.get(paymentIdx);
      paymentObject.paymentMethod = payment.get('paymentMethod');
      paymentObject.dueDateOffsetType = payment.get('dueDateOffsetType');
      paymentObject.dueDateOffsetValue = payment.get('dueDateOffsetValue');
      paymentObject.dueDate = payment.get('dueDate');
      paymentObject.anchor = payment.get('dueDateAnchorType');
      paymentObject.estimatedDueDate = payment.get('estimatedDueDate');
      paymentObject.estimatedDueAmount = payment.get('estimatedDueAmount');
      paymentObject.dueAmount = payment.get('dueAmount');
      paymentObject.dueAmountCurrency = payment.get('dueAmountCurrency');
      paymentObject.fullCostType = payment.get('fullCostType');
      paymentObject.fullCostPercent = payment.get('fullCostPercent');
      this.validateDueDate(paymentObject.anchor, paymentObject.dueDate);
    } else {
      this.applyDefaultValues = true;
      this.validateDueDate(paymentObject.anchor, paymentObject.dueDate);
    }
    this.setState({
      paymentIdx,
      paymentObject,
    });
  }
  validateDueDate(anchor, dueDate) {
    if (anchor == 'DATE' && !dueDate) {
      this.setState({ saveDisabled: true });
    } else if (this.state.saveDisabled) {
      this.setState({ saveDisabled: false });
    }
  }
  updatePaymentMethod(value) {
    if (this.applyDefaultValues) {
      this.setDefaultValues(value && value.label);
    }
    this.setState({ paymentObject:
       Object.assign(this.state.paymentObject, { paymentMethod: value && value.value }) });
  }

  updatePaymentObject(field, value) {
    this.applyDefaultValues = false;
    this.setState({ paymentObject:
       Object.assign(this.state.paymentObject, { [field]: value }) });
    let anchor = this.state.paymentObject.anchor;
    let dueDate = this.state.paymentObject.dueDate;
    switch (field) {
      case 'anchor':
        anchor = value;
        break;
      case 'dueDate':
        dueDate = value;
        break;
      default:
        break;
    }
    this.validateDueDate(anchor, dueDate);
  }

  createPaymentViews() {
    const hasBalance = this.props.product && this.props.product.get('payments', new List())
      .filter((p, idx) => p.get('fullCostType') == 'BALANCE'
      && idx !== this.state.paymentIdx).size > 0;
    return (
      <div className="custom-contract-payments">
        <Row>
          <Col xs={12}>
            <strong>Payment method</strong>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <RefPicker
              dict="paymentmethod"
              name="paymentMethod"
              defaultValue={this.state.paymentObject.paymentMethod}
              onChangeFunc={(val) => {
                this.updatePaymentMethod(val);
              }}
            />
          </Col>
        </Row>
        <div style={{ marginTop: 5 }}>
          <Row>
            <Col xs={12}>
              <strong>Due date</strong>
            </Col>
          </Row>
          <Row style={{ marginBottom: 5 }}>
            <Col xs={3} className="due-date-offset">
              <FancyInput
                className="form-control"
                thousand
                positive
                negative={false}
                type="number"
                value={this.state.paymentObject.dueDateOffsetValue}
                onChange={(e, val) => this.updatePaymentObject('dueDateOffsetValue', val)}
                disabled={this.state.paymentObject.dueDateOffsetType == 'BY'}
                id="dueDateOffsetValue" name="dueDateOffsetValue"

              />
              {this.state.paymentObject.dueDateOffsetType != 'BY' && <span> days</span>}
            </Col>
            <Col xs={4}>
              <Select
                id="dueDateOffsetType"
                name="dueDateOffsetType"
                clearable={false}
                value={this.state.paymentObject.dueDateOffsetType}
                //  disabled={this.state.paymentObject.anchor == 'DATE'}
                options={[
                  { value: 'BY', label: 'Latest By' },
                  { value: 'BEFORE', label: 'Before' },
                  { value: 'AFTER', label: 'After' },
                ]}
                onChange={(option) => {
                  if (option && option.value) {
                    if (option.value == 'BY') {
                      this.updatePaymentObject('dueDateOffsetValue', '');
                      this.updatePaymentObject('anchor', 'DATE');
                    } else if (this.state.paymentObject.dueDateOffsetType == 'BY') {
                      this.updatePaymentObject('anchor', 'BLDATE');
                    }
                  }
                  this.updatePaymentObject('dueDateOffsetType', (option && option.value) || 'BY');
                }}
              />
            </Col>
            <Col xs={5}>
              {this.state.paymentObject.anchor == 'DATE' ?
                <RequiredFormControl
                  component={DateTimePicker}
                  format={dateTimePickerFormat}
                  time={false}
                  name="dueDate"
                  onChange={(val) => {
                    this.updatePaymentObject('dueDate',
                      val ? moment(val).format('DD MMM YYYY') : undefined);
                  }}
                  defaultValue={this.state.paymentObject.dueDate
                    ? new Date(this.state.paymentObject.dueDate)
                    : undefined}
                />
                :
                <Select
                  id="anchors"
                  name="anchors"
                  clearable={false}
                  value={this.state.paymentObject.anchor}
                  options={[
                    { value: 'BLDATE', label: 'BL date' },
                    { value: 'LAYCAN', label: 'Laycan' },
                    { value: 'CONTRACT', label: 'Contract date' },
                    { value: 'DATE', label: 'Date' },
                  ]}
                  disabled={this.state.paymentObject.dueDateOffsetType == 'BY'}
                  onChange={(option) => {
                    this.updatePaymentObject('anchor', (option && option.value) || 'BLDATE');
                    if (option && option.value && option.value == 'DATE') {
                      this.updatePaymentObject('dueDateOffsetType', 'BY');
                      this.updatePaymentObject('dueDateOffsetValue', '');
                    }
                  }}
                />
              }
            </Col>
          </Row>
        </div>
        <div>
          <Row>
            <Col xs={12}>
              <strong>Due amount</strong>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Row>
                <Label xs={6} label="Amount type">
                  <Select
                    id="fullCost"
                    name="fullCost"
                    clearable={false}
                    value={this.state.paymentObject.fullCostType}
                    options={[
                      { value: 'VALUE', label: 'Value' },
                      { value: 'PERCENT', label: '%' },
                      { value: 'BALANCE', label: 'Balance', disabled: hasBalance },
                    ]}
                    onChange={(option) => {
                      this.updatePaymentObject('fullCostType', option && option.value);
                      if (option && option.value == 'VALUE') {
                        this.updatePaymentObject('fullCostPercent', '');
                      }
                      if (option && option.value == 'PERCENT') {
                        this.updatePaymentObject('dueAmount', '');
                        this.updatePaymentObject('fullCostPercent', 100);
                      }
                    }}
                  />
                </Label>
              </Row>
            </Col>
            <Col md={6} >
              <Row>
                <Label
                  xs={4}
                  label={this.state.paymentObject.fullCostType == 'BALANCE' ?
                    '' : 'Amount'}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Row>
                    {this.state.paymentObject.fullCostType == 'VALUE' &&
                      <Col xs={3} style={{ paddingLeft: '2px', paddingRight: 0 }}>
                        <CurrencyInput
                          noRates
                          name="dueAmountCurrency"
                          onChange={val =>
                            this.updatePaymentObject('dueAmountCurrency', val)}
                          defaultValue={this.state.paymentObject.fullCostType != 'VALUE'
                            ? this.props.product.get('priceCurrency')
                            : this.state.paymentObject.dueAmountCurrency}
                          defaultValueRates={usdDefaultCurrencyRates()}
                        />
                      </Col>
                    }
                    {this.state.paymentObject.fullCostType == 'VALUE' &&
                      <Col xs={9} style={{ paddingLeft: '2px' }}>
                        <FancyInput
                          className="form-control"
                          thousand
                          fraction={2}
                          positive
                          negative={false}
                          type="number"
                          value={this.state.paymentObject.dueAmount}
                          onChange={(e, val) => this.updatePaymentObject('dueAmount', val)}
                          id="dueAmount" name="dueAmount"
                          disabled={this.state.paymentObject.fullCostType != 'VALUE'}
                        />
                      </Col>}
                    {this.state.paymentObject.fullCostType == 'PERCENT' &&
                      <Col xs={12}>
                        <div style={{ display: 'flex' }}>
                          <FancyInput
                            className="form-control"
                            thousand
                            fraction={2}
                            positive
                            negative={false}
                            maxValue={100}
                            type="number"
                            value={this.state.paymentObject.fullCostPercent}
                            onChange={(e, val) =>
                              this.updatePaymentObject('fullCostPercent', val)}
                            id="fullCostPercent" name="fullCostPercent"
                            disabled={this.state.paymentObject.fullCostType == 'VALUE'
                          || this.state.paymentObject.fullCostType == 'BALANCE'}
                          />
                        </div>
                      </Col>
                    }
                  </Row>
                </Label>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    );
  }


  closeCreatePaymentModal() {
    this.props.closeModal();
  }

  /* eslint-disable  */
  applyPage(payment, paymentObject) {
        payment.paymentMethod = paymentObject.paymentMethod;
        payment.dueDateOffsetType = paymentObject.dueDateOffsetType;
        payment.dueDateOffsetValue = paymentObject.dueDateOffsetValue;

        const contractPaymentExpenseType =
          this.props.expensestypes.find(elem => elem.get('name', '')
            .toLowerCase() == PRODUCT_EXPENSES_TYPE, this, new Map());
        payment.expensesType = contractPaymentExpenseType.get('id');

        let dueDate = undefined;
        if (paymentObject.anchor == 'DATE') {
          dueDate = paymentObject.dueDate;
        }
        payment.dueDateAnchorType = paymentObject.anchor;
        payment.dueDate = dueDate;
        const productCurrency = this.props && this.props.product ? this.props.product.get('priceCurrency', Currency.DOLLAR) : Currency.DOLLAR
        switch (paymentObject.fullCostType) {
          case 'PERCENT':
            payment.fullCostPercent = paymentObject.fullCostPercent;
            payment.estimatedDueAmount = undefined;
            payment.dueAmountCurrency = productCurrency;
            break;
          case 'VALUE':
            payment.dueAmount = paymentObject.dueAmount;
            payment.dueAmountCurrency = paymentObject.dueAmountCurrency || productCurrency || Currency.DOLLAR;
            payment.estimatedDueAmount=undefined;
            break;
          case 'BALANCE':
            payment.estimatedDueAmount = paymentObject.estimatedDueAmount;
            payment.dueAmountCurrency = productCurrency;
            break;
          default:
            break;
        }
        payment.counterparty= this.props.contractor;
        payment.fullCostType = paymentObject.fullCostType;
  }
  /* eslint-enable  */
  addNewPayment() {
    const timeAdded = new Date().getTime();
    let payment = { operationOfficer: this.props.currentUser,
      isDebit: this.props.dealType == 'purchase',
      dealtype: this.props.dealType };
    const { paymentObject } = this.state;
    payment.isCustomContractPayment = true;
    const paymentIdx = this.props.resolvePaymentIdx && this.props.resolvePaymentIdx();
    if (paymentIdx || paymentIdx === 0) {
      payment = this.props.payments.get(paymentIdx).toJS();
      this.applyPage(payment, paymentObject);
      this.props.updateDealPayment(paymentIdx, payment);
    } else {
      payment.timeAdded = timeAdded;
      this.applyPage(payment, paymentObject);
      this.props.addDealPayment(payment);
    }
    this.closeCreatePaymentModal();
  }

  cancelButton() {
    return (
      <Button
        style={{ width: '71px', height: '30px', padding: '2px 6px' }}
        onClick={this.closeCreatePaymentModal}
      >
        Cancel
      </Button>
    );
  }

  proceedButton() {
    return (
      <Button
        bsStyle="primary"
        disabled={this.state.saveDisabled}
        style={{ width: '71px', height: '30px', padding: '2px 6px' }}
        onClick={this.addNewPayment}
      >
        Save
      </Button>
    );
  }

  render() {
    const paymentIdx = this.props.resolvePaymentIdx && this.props.resolvePaymentIdx();
    return (
      <Modal
        onHide={this.closeCreatePaymentModal}
        bsSize="medium"
        show={this.props.show}
      >
        <Modal.Header style={{ padding: '5px 20px', fontSize: '15px' }}>
          {paymentIdx || paymentIdx === 0 ? 'Edit ' : 'Create '}payment
        </Modal.Header>
        <Modal.Body style={{ fontSize: '12px' }}>
          {this.createPaymentViews()}
        </Modal.Body>
        <Modal.Footer style={{ padding: '5px 20px', fontSize: '15px' }}>
          {this.cancelButton()}
          {this.proceedButton()}
        </Modal.Footer>
      </Modal>
    );
  }
}

CreatePaymentModal.propTypes = {
  idx: React.PropTypes.number.isRequired,
  show: React.PropTypes.bool,
  closeModal: React.PropTypes.func,
  currentUser: React.PropTypes.number,
  product: React.PropTypes.object.isRequired,
  payments: React.PropTypes.object,
  dealType: React.PropTypes.string.isRequired,
  contractDate: React.PropTypes.string.isRequired,
  expensestypes: React.PropTypes.object,
  resolvePaymentIdx: React.PropTypes.func,
  addDealPayment: React.PropTypes.func,
  updateDealPayment: React.PropTypes.func,
};

export default connect((state, props) => ({
  currentUser: Number(state.getIn(['session', 'id'])),
  expensestypes: state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List()),
  payments: state.getIn(['data', 'deals', 'deal', 'products', props.idx, 'payments'], new List()),
}), (dispatch, props) => ({
  addDealPayment(payment) {
    addDealPayment(dispatch, props.idx, [], payment, true);
  },
  updateDealPayment(paymentIdx, payment) {
    const paymentIdxs = [];
    paymentIdxs.push(paymentIdx);
    updateDealPayment(dispatch, props.idx, paymentIdxs, payment);
  },
}))(CreatePaymentModal);
